import { createContext, useContext } from "react"

import type { RoutesContextType } from "./routes.types"

import { logger } from "@/lib/logger"

const defaultRoutesContext: RoutesContextType = {
  routes: [],
  routeObjects: [],
  trainingModules: [],
  trainingTracks: [],
  trainingRoutes: null,
  trainingEnabled: false,
  getRouteById: () => undefined,
  getRoutePath: () => "/explorer",
  getRouteChatPath: () => "/chat",
}

let hasWarnedMissingProvider = false

export const RoutesContext = createContext<RoutesContextType>(defaultRoutesContext)

export const useRoutes = () => {
  const context = useContext(RoutesContext)
  if (context === defaultRoutesContext && !hasWarnedMissingProvider) {
    hasWarnedMissingProvider = true
    logger.warn("useRoutes called without RoutesProvider")
  }
  return context
}
